import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'p-separator',
  templateUrl: './p-separator.component.html',
  styleUrls: ['./p-separator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PSeparatorComponent {}
